export default __webpack_public_path__ + "static/media/gold.a85bf757.svg";